import template from './sw-cms-block-acris-blog-image-slider.html.twig';

const { Component } = Shopware;

Component.register('sw-cms-block-acris-blog-image-slider', {
    template
});
